import { Label } from "../ui/label";

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
    <div>
      <h1 className="font-serif text-4xl font-medium text-[#FAF6F0]">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-[#A1A1AA]">{subtitle}</p>}
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

export const Field = ({ label, hint, children, className = "" }) => (
  <div className={`space-y-2 ${className}`}>
    <Label className="text-xs uppercase tracking-[0.15em] text-[#A1A1AA]">{label}</Label>
    {children}
    {hint && <p className="text-[11px] text-[#A1A1AA]/70">{hint}</p>}
  </div>
);

export const Panel = ({ title, children, className = "", testid }) => (
  <section className={`rounded-2xl border border-[#D4AF37]/12 bg-[#141417] p-6 ${className}`} data-testid={testid}>
    {title && <h2 className="mb-5 font-serif text-2xl text-[#F3E5AB]">{title}</h2>}
    {children}
  </section>
);

export const GoldButton = ({ className = "", ...props }) => (
  <button className={`inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-[#D4AF37] to-[#997A15] px-5 py-2.5 text-sm font-semibold text-[#0B0B0C] transition-[filter,box-shadow] hover:shadow-[0_0_18px_rgba(212,175,55,0.35)] hover:brightness-110 disabled:pointer-events-none disabled:opacity-50 ${className}`} {...props} />
);

export const GhostButton = ({ className = "", ...props }) => (
  <button className={`inline-flex items-center justify-center gap-2 rounded-full border border-white/10 px-4 py-2 text-sm text-[#E8E2D6] transition-colors hover:border-[#D4AF37]/50 hover:text-[#F3E5AB] disabled:pointer-events-none disabled:opacity-40 ${className}`} {...props} />
);
